var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBatchPaid = function SvgBatchPaid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.625 8.223c.72.51 2.04.738 3.375.738 1.318 0 2.637-.229 3.375-.738v.738c0 .633-1.512 1.125-3.375 1.125S3.625 9.594 3.625 8.96zm0-1.846c.72.598 2.04.896 3.375.896 1.318 0 2.637-.298 3.375-.896v.896c0 .633-1.512 1.125-3.375 1.125s-3.375-.492-3.375-1.125zM7 3.898c1.863 0 3.375.633 3.375 1.407 0 .79-1.512 1.406-3.375 1.406s-3.375-.615-3.375-1.406c0-.774 1.512-1.407 3.375-1.407"
  })));
};
export default SvgBatchPaid;